import { createApp } from "vue";
import RegistrationForm from "./components/RegistrationForm.vue";

const el = document.getElementById("registration-form-app");
if (el) {
  const config = JSON.parse(el.dataset.config || "{}");
  const app = createApp(RegistrationForm, { config });
  app.mount(el);
}
